import { PRODUCT_NAME, PRODUCT_ORG } from "@/lib/branding";
import { useWorkspaceBranding } from "@/lib/workspaceBranding";
import { cn } from "@/lib/utils";

type BrandWordmarkProps = {
  title: string;
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  /** When false, only show the short title (e.g. icon-collapsed chrome). */
  showSubtitle?: boolean;
};

/**
 * Product chrome: short title (SIGMA) + “by Latino Business Support” for the
 * home org; other companies see their own name under the title.
 */
export function BrandWordmark({
  title,
  className,
  titleClassName,
  subtitleClassName,
  showSubtitle = true,
}: BrandWordmarkProps) {
  const { workspaceName, tagline } = useWorkspaceBranding();
  return (
    <span className={cn("min-w-0", className)} title={workspaceName}>
      <span
        className={cn(
          "block truncate font-semibold leading-tight",
          titleClassName,
        )}
      >
        {title}
      </span>
      {showSubtitle ? (
        <span
          className={cn(
            "block truncate text-2xs font-normal leading-tight text-muted-foreground",
            subtitleClassName,
          )}
        >
          {tagline == null
            ? `by ${PRODUCT_ORG}`
            : tagline === title
              ? `on ${PRODUCT_NAME}`
              : tagline}
        </span>
      ) : null}
    </span>
  );
}
